export default "__VITE_ASSET__3bbfc973__"